import * as Yup from 'yup';

export const voicePolicySchema = Yup.object().shape({
    name: Yup.string().required('Voice Policy name is required'),
    pattern: Yup.string().required('Pattern is required'),
});
